import { render, staticRenderFns } from "./DeviceHistory.vue?vue&type=template&id=c668220e"
import script from "./DeviceHistory.vue?vue&type=script&lang=js"
export * from "./DeviceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports